/* Foil & Foundry Co. animated background: drifting holo cards (logo on the backs) over gold and silver glows */
(function () {
  const cv = document.getElementById("mez-bg");
  if (!cv) return;
  const ctx = cv.getContext("2d");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  let running = !reduce;
  try { if (localStorage.getItem("mez-bg-paused") === "1") running = false; } catch (e) {}
  let W, H, dpr, cards = [], blobs = [], mx = 0, my = 0, tmx = 0, tmy = 0, last = 0;
  const HUES = [[226, 169, 62], [208, 138, 34], [246, 215, 138], [196, 202, 212], [160, 166, 178]]; // gold + silver, from the logo
  const LOGO = new Image();
  if (cv.dataset.logo) LOGO.src = cv.dataset.logo;
  const density = Number(cv.dataset.density || 1);

  function mk(anywhere) {
    const z = 0.35 + Math.random() * 0.65;
    return { x: Math.random() * W, y: anywhere ? Math.random() * H : H + 120, z, w: 38 + z * 58, a: Math.random() * Math.PI * 2, va: (Math.random() - 0.5) * 0.004, vy: -(0.12 + z * 0.38), vx: (Math.random() - 0.5) * 0.12, flip: Math.random() * Math.PI * 2, vf: 0.006 + Math.random() * 0.01, h: HUES[Math.floor(Math.random() * HUES.length)] };
  }
  function resize() {
    dpr = Math.min(devicePixelRatio || 1, 2); W = innerWidth; H = innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const n = Math.round(Math.min(26, Math.max(10, (W * H) / 52000)) * density);
    cards = Array.from({ length: n }, () => mk(true));
    blobs = HUES.slice(0, 4).map((c, i) => ({ c, x: Math.random() * W, y: Math.random() * H, r: Math.max(W, H) * (0.28 + Math.random() * 0.18), sx: (Math.random() - 0.5) * 0.15, sy: (Math.random() - 0.5) * 0.15, ph: i * 1.7 }));
  }
  function rr(x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
  function frame(t) {
    const dt = Math.min(3, (t - last) / 16.7 || 1); last = t;
    ctx.clearRect(0, 0, W, H);
    tmx += (mx - tmx) * 0.05; tmy += (my - tmy) * 0.05;
    ctx.globalCompositeOperation = "lighter";
    for (const b of blobs) {
      b.x += b.sx * dt; b.y += b.sy * dt; b.ph += 0.003 * dt;
      if (b.x < -b.r * 0.3 || b.x > W + b.r * 0.3) b.sx *= -1;
      if (b.y < -b.r * 0.3 || b.y > H + b.r * 0.3) b.sy *= -1;
      const r = b.r * (1 + Math.sin(b.ph) * 0.08), [R, G, B] = b.c;
      const g = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, r);
      g.addColorStop(0, `rgba(${R},${G},${B},.07)`); g.addColorStop(1, `rgba(${R},${G},${B},0)`);
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    }
    ctx.globalCompositeOperation = "source-over";
    cards.sort((a, b) => a.z - b.z);
    for (let i = 0; i < cards.length; i++) {
      const c = cards[i];
      c.y += c.vy * dt; c.x += c.vx * dt; c.a += c.va * dt; c.flip += c.vf * dt;
      if (c.y < -150) { cards[i] = mk(false); continue; }
      const px = c.x + tmx * c.z * 24, py = c.y + tmy * c.z * 24, sx = Math.cos(c.flip), w = c.w, h = (w * 88) / 63;
      ctx.save(); ctx.translate(px, py); ctx.rotate(c.a); ctx.scale(Math.max(0.08, Math.abs(sx)), 1);
      ctx.globalAlpha = 0.22 * c.z;
      const [R, G, B] = c.h, g = ctx.createLinearGradient(-w / 2, -h / 2, w / 2, h / 2);
      if (sx > 0) {
        const s = (Math.sin(c.flip * 2) + 1) / 2;
        g.addColorStop(0, `rgb(${R},${G},${B})`); g.addColorStop(Math.max(0.05, Math.min(0.95, s)), "rgb(255,255,255)"); g.addColorStop(1, `rgb(${(R * 0.55) | 0},${(G * 0.55) | 0},${(B * 0.55) | 0})`);
      } else { g.addColorStop(0, `rgb(${(R * 0.5) | 0},${(G * 0.5) | 0},${(B * 0.6) | 0})`); g.addColorStop(1, `rgb(${(R * 0.3) | 0},${(G * 0.3) | 0},${(B * 0.5) | 0})`); }
      rr(-w / 2, -h / 2, w, h, w * 0.08); ctx.fillStyle = g; ctx.fill();
      if (sx > 0) {
        ctx.globalAlpha *= 0.7; ctx.fillStyle = "rgba(10,12,20,.45)";
        rr(-w * 0.4, -h * 0.4, w * 0.8, h * 0.42, 3); ctx.fill();
        ctx.fillRect(-w * 0.4, h * 0.1, w * 0.8, h * 0.05); ctx.fillRect(-w * 0.4, h * 0.2, w * 0.5, h * 0.04);
      } else if (LOGO.complete && LOGO.naturalWidth) {
        ctx.save(); rr(-w / 2, -h / 2, w, h, w * 0.08); ctx.clip(); ctx.globalAlpha = Math.min(1, ctx.globalAlpha * 2.6);
        ctx.globalCompositeOperation = "lighter"; const s = w * 1.05; ctx.drawImage(LOGO, -s / 2, -s / 2, s, s); ctx.restore();
        rr(-w / 2, -h / 2, w, h, w * 0.08); ctx.strokeStyle = "rgba(226,169,62,.6)"; ctx.lineWidth = 1.5; ctx.stroke();
      }
      ctx.restore();
    }
    if (running && !document.hidden) requestAnimationFrame(frame);
  }
  addEventListener("resize", resize);
  addEventListener("pointermove", (e) => { mx = e.clientX / W - 0.5; my = e.clientY / H - 0.5; });
  document.addEventListener("visibilitychange", () => { if (!document.hidden && running) { last = performance.now(); requestAnimationFrame(frame); } });
  const btn = document.getElementById("mez-bg-toggle");
  function setBtn() { if (!btn) return; btn.textContent = running ? "Pause motion" : "Play motion"; btn.setAttribute("aria-pressed", String(!running)); }
  if (btn) btn.addEventListener("click", () => {
    running = !running; setBtn();
    try { localStorage.setItem("mez-bg-paused", running ? "0" : "1"); } catch (e) {}
    if (running) { last = performance.now(); requestAnimationFrame(frame); }
  });
  resize(); setBtn(); LOGO.onload = () => { if (!running) requestAnimationFrame(frame); };
  requestAnimationFrame(frame);
})();
